import {
  Injectable,
  Signal,
  WritableSignal,
  computed,
  signal,
} from '@angular/core';
import { CreditCard } from '../models/core/credit-card.model';
import { GiftCard } from '../models/core/gift-card.model';

@Injectable({
  providedIn: 'root',
})
export class WalletEditorService {
  private _state: WritableSignal<CreditCard | GiftCard | null> = signal<
    CreditCard | GiftCard | null
  >(null);

  public state: Signal<CreditCard | GiftCard | null> = computed(() =>
    this._state()
  );

  public updateState(value: CreditCard | GiftCard | null) {
    this._state.set(value);
  }
}
